import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, onMounted, computed } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';
import FundHistoryOne from '@/themes/themeOne/fundsHistory/fundHistory.vue';
import FundHistoryTwo from '@/themes/themeTwo/fundsHistory/fundHistory.vue';
import FundHistoryThree from '@/themes/themeThree/fundsHistory/fundHistory.vue';
import { CardDataItem, FundHistoryData, FUNDS_TABS, PAGE_SIZE } from './supportScript';
import { getUserFundHistory } from '@/api/fundsHistory';


export default /*@__PURE__*/_defineComponent({
  __name: 'fundHistory',
  props: {
    isTabView: { type: Boolean }
  },
  setup(__props: any) {

const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref();
const toastContent = ref('');
const loadingRef = ref();

const active = ref(2);
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const tabList = ref(FUNDS_TABS)
const total = ref(0)
const dataLog = ref<CardDataItem[]>([])
const props = __props
const dataSet = computed<FundHistoryData>(() => ({
    active: active.value,
    total: total.value,
    pageSize: pageSize.value,
    pageNum: pageNum.value,
    tabList: tabList.value,
    dataLog: dataLog.value
}))


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const onClickTab = (data: any) => {
    active.value = data.name
    total.value = 0
    pageNum.value = 1
    dataLog.value = []
    getUserFundHistoryData()
}
const getUserFundHistoryData = () => {
    loadingRef.value.open()
    let data = {
        pageSize: pageSize.value,
        pageNum: pageNum.value,
        logType: active.value
    }
    getUserFundHistory(data).then(res => {
        loadingRef.value.close()
        const resData = res.data
        total.value = resData.total || 0
        dataLog.value = [...dataLog.value, ...resData.records]
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err);
        }
    })
}

const getNextPageList = () => {
    loadingRef.value.open()
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getUserFundHistoryData()
    }
}

onMounted(() => {
    getUserFundHistoryData()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(FundHistoryOne, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onGetNextPageList: getNextPageList
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FundHistoryTwo, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onGetNextPageList: getNextPageList
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(FundHistoryThree, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onGetNextPageList: getNextPageList,
            "is-tab-view": _ctx.isTabView
          }, null, 8, ["data-set", "is-tab-view"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})